import React, { useContext, useState } from 'react';
import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import CustomizerContext from '../../_helper/Customizer';

const SidebarLogo = () => {
  const { toggleSidebar } = useContext(CustomizerContext);
  const [toggle, setToggle] = useState(false);

  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };

  return (
    <div className='logo-wrapper' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <Link to='/dashboard' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src='/logo-branca.png' alt='Topo Prospect' style={{ height: 52, width: 'auto' }} />
      </Link>
      <div className='back-btn' onClick={openCloseSidebar}>
        <i className='fa fa-angle-left'></i>
      </div>
      <div className='toggle-sidebar' onClick={openCloseSidebar}>
        <Grid className='status_toggle middle sidebar-toggle' />
      </div>
    </div>
  );
};

export default SidebarLogo;
